import { Color } from "@bonliva-crm/ui";
import { Box, Button, Tab, Tabs, makeStyles } from "@material-ui/core";

type Props = {
  currentTab: string;
  onTabChange: (tab: string) => void;
};

export function ConsultantPipelineMenu(props: Props) {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<any>, newValue: string) => {
    props.onTabChange(newValue);
  };

  return (
    <Box display="flex" flexDirection="row" bgcolor={Color.OffWhite} p={0} id="test1">
      <Tabs value={props.currentTab} className={classes.tabs} onChange={handleChange}>
        <Tab label="Konsulter" value="consultants" className={classes.tab} />
        <Tab label="Presentationer" value="presentations" className={classes.tab} />
        <Tab label="Statistik" value="stats" className={classes.tab} />
        <Tab
          label="Bokningshistorik"
          value="booking-history"
          className={classes.tab}
          disabled
        />
      </Tabs>

      <Box display="flex" alignItems="center" ml={2}>
        <Button color="primary" variant="contained" disabled>
          Create
        </Button>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles({
  tabs: {
    backgroundColor: "transparent",
    boxShadow: "none"
  },
  tab: {
    padding: "16px",
    fontSize: "18px"
  }
});
